import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "@/lib/scroll";
import { PRICE_COLLECTIONS } from "@/data/site";
import { ProductImage } from "./ProductImage";

export const PriceCollections = ({ onSelectPrice }) => {
  const handleSelect = (max) => {
    onSelectPrice(max);
    scrollToId("#katalog");
  };

  return (
    <section id="fiyat-koleksiyonlari" data-testid="price-collections-section" className="py-16 md:py-24 lg:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Bütçenize Göre"
          title={<>Fiyata Göre <span className="italic text-emerald">Koleksiyonlar</span></>}
          testId="price-collections"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {PRICE_COLLECTIONS.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.1}>
              <button
                onClick={() => handleSelect(c.id)}
                data-testid={c.testId}
                className="group relative block w-full text-left aspect-[4/5] sm:aspect-[3/4] overflow-hidden bg-emerald"
              >
                <div className="absolute inset-0 bg-white">
                  <ProductImage
                    src={c.image}
                    alt={c.label}
                    className="h-full w-full object-contain p-8 transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-deep/95 via-emerald-deep/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/60">Koleksiyon</p>
                  <p className="mt-2 font-serif text-3xl sm:text-4xl font-semibold text-ivory">{c.label}</p>
                  <p className="mt-2 text-sm text-ivory/60">{c.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[13px] font-semibold text-ivory/85 transition-colors group-hover:text-white">
                    Ürünleri Gör
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
